import { render, staticRenderFns } from "./LoadingComp.vue?vue&type=template&id=0a02dd98"
import script from "./LoadingComp.vue?vue&type=script&lang=js"
export * from "./LoadingComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports